import { tokens } from "@manifesthhqinc/ui-library";
import styled from "styled-components";

export const SandboxBanner = styled.div`
  width: 100%;
  height: 200px;
  background: ${tokens.color.brand["100"]};
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
